// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/asset_custom_events.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Asset } from "./asset_pb.js";
import { file_transportation_v1_asset } from "./asset_pb.js";
import type { Address, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/asset_custom_events.proto.
 */
export const file_transportation_v1_asset_custom_events: GenFile = /*@__PURE__*/
  fileDesc("Cit0cmFuc3BvcnRhdGlvbi92MS9hc3NldF9jdXN0b21fZXZlbnRzLnByb3RvEhF0cmFuc3BvcnRhdGlvbi52MSKRAQoZQXNzZXRGYWNpbGl0eVVwZGF0ZWRFdmVudBInCgVhc3NldBgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLkFzc2V0EicKFHByZXZpb3VzX2ZhY2lsaXR5X2lkGAIgASgLMgkudHlwZXMuSUQSIgoPbmV3X2ZhY2lsaXR5X2lkGAMgASgLMgkudHlwZXMuSUQilQEKGUFzc2V0TG9jYXRpb25VcGRhdGVkRXZlbnQSJwoFYXNzZXQYASABKAsyGC50cmFuc3BvcnRhdGlvbi52MS5Bc3NldBIpChFwcmV2aW91c19sb2NhdGlvbhgCIAEoCzIOLnR5cGVzLkFkZHJlc3MSJAoMbmV3X2xvY2F0aW9uGAMgASgLMg4udHlwZXMuQWRkcmVzcyKWAQoaQXNzZXRGaWxsU3RhdGVDaGFuZ2VkRXZlbnQSJwoFYXNzZXQYASABKAsyGC50cmFuc3BvcnRhdGlvbi52MS5Bc3NldBIbChNwcmV2aW91c19maWxsX3N0YXRlGAIgASgJEhYKDm5ld19maWxsX3N0YXRlGAMgASgJEhoKB3Rhc2tfaWQYBCABKAsyCS50eXBlcy5JREJBWj9wYWNrYWdlcy9iYWNrZW5kLW1vZHVsZS10cmFuc3BvcnRhdGlvbi9hcGkvdjE7dHJhbnNwb3J0YXRpb25fdjFiCGVkaXRpb25zcOgH", [file_transportation_v1_asset, file_types]);

/**
 * @generated from message transportation.v1.AssetFacilityUpdatedEvent
 */
export type AssetFacilityUpdatedEvent = Message<"transportation.v1.AssetFacilityUpdatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Asset asset = 1;
   */
  asset?: Asset;

  /**
   * @generated from field: types.ID previous_facility_id = 2;
   */
  previousFacilityId?: ID;

  /**
   * @generated from field: types.ID new_facility_id = 3;
   */
  newFacilityId?: ID;
};

/**
 * Describes the message transportation.v1.AssetFacilityUpdatedEvent.
 * Use `create(AssetFacilityUpdatedEventSchema)` to create a new message.
 */
export const AssetFacilityUpdatedEventSchema: GenMessage<AssetFacilityUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset_custom_events, 0);

/**
 * @generated from message transportation.v1.AssetLocationUpdatedEvent
 */
export type AssetLocationUpdatedEvent = Message<"transportation.v1.AssetLocationUpdatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Asset asset = 1;
   */
  asset?: Asset;

  /**
   * @generated from field: types.Address previous_location = 2;
   */
  previousLocation?: Address;

  /**
   * @generated from field: types.Address new_location = 3;
   */
  newLocation?: Address;
};

/**
 * Describes the message transportation.v1.AssetLocationUpdatedEvent.
 * Use `create(AssetLocationUpdatedEventSchema)` to create a new message.
 */
export const AssetLocationUpdatedEventSchema: GenMessage<AssetLocationUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset_custom_events, 1);

/**
 * @generated from message transportation.v1.AssetFillStateChangedEvent
 */
export type AssetFillStateChangedEvent = Message<"transportation.v1.AssetFillStateChangedEvent"> & {
  /**
   * @generated from field: transportation.v1.Asset asset = 1;
   */
  asset?: Asset;

  /**
   * @generated from field: string previous_fill_state = 2;
   */
  previousFillState: string;

  /**
   * @generated from field: string new_fill_state = 3;
   */
  newFillState: string;

  /**
   * @generated from field: types.ID task_id = 4;
   */
  taskId?: ID;
};

/**
 * Describes the message transportation.v1.AssetFillStateChangedEvent.
 * Use `create(AssetFillStateChangedEventSchema)` to create a new message.
 */
export const AssetFillStateChangedEventSchema: GenMessage<AssetFillStateChangedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset_custom_events, 2);

